import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'
import styles from './index.module.scss'

const Loading: React.FC<BaseIconProps> = React.forwardRef(
  ({ className, size = 'md', color = 'default' }, ref) => (
    <svg
      className={[styles.Loading, className].join(' ')}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 200 200"
      color={IconColors[color]}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
    >
      <defs>
        <linearGradient id="spinner-secondHalf">
          <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient id="spinner-firstHalf">
          <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
      </defs>

      <g strokeWidth="10">
        <path
          stroke="url(#spinner-secondHalf)"
          d="M 4 100 A 96 96 0 0 1 196 100"
        />
        <path
          stroke="url(#spinner-firstHalf)"
          d="M 196 100 A 96 96 0 0 1 4 100"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          d="M 4 100 A 96 96 0 0 1 4 98"
        />
      </g>
    </svg>
  ),
)

export default Loading
